import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { AddCampaignsToEntityComponent } from 'src/app/campaigns/add-campaigns-to-entity/add-campaigns-to-entity.component';
import { CampaignsContactsService } from 'src/app/campaigns/campaigns-contacts.service';
import { CoreDialogService } from 'src/app/core/dialogs/core-dialog.service';
import { ComponentService } from 'src/app/core/view/component.service';
import { ViewComponent } from 'src/app/core/view/view.component';
import { ViewsService } from 'src/app/core/view/views.service';
import { MailMarketingNotificationToStatsComponent } from 'src/app/mail-marketing/mail-marketing-notification-to-stats/mail-marketing-notification-to-stats.component';
import { MailingDetailComponent } from 'src/app/mailing/mailing-detail/mailing-detail.component';
import { ContactsService } from 'src/app/organizations/organizations-detail/organizations-contacts-detail/contacts.service';
import { OrganizationsService } from 'src/app/organizations/organizations.service';
import { Location } from '@angular/common';

@Component({
  selector: 'app-tasks-create-contact',
  templateUrl: './tasks-create-contact.component.html',
  styleUrls: ['./tasks-create-contact.component.scss']
})
export class TasksCreateContactComponent {
  public contact: any = {};
  public task_id;
  public organization: any = {};
  public last_organization_id;
  public previousUrl;
  @ViewChild("view") public view: ViewComponent;
  constructor(
    private route: ActivatedRoute,
    private organizationsService: OrganizationsService,
    private campaignContactsService: CampaignsContactsService,
    private messageService: MessageService,
    private contactService: ContactsService,
    private coreDialogService: CoreDialogService,
    private dialogService: DialogService,
    private router: Router,
    private viewsService: ViewsService,
    private _location: Location,
    private translateService: TranslateService,
    public componentService: ComponentService,
    private config: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef
  ) { }

  ngOnInit(): void {
    this.contact.organization_id = this.config.data.organization_id;
    this.contact.task_id = this.config.data.task_id;
    this.contact.lockOrganization = true;
    this.task_id = this.config.data.task_id;
    this.loadDataOrganization(this.contact.organization_id);
  }
  loadDataOrganization(id: number) {
    this.organizationsService.get(id).subscribe({
      next: (data: any) => {
        this.organization = data;
      },
      error: (error: any) => {
        this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: error.error.title });
      }
    })
  }
  cancel() {
    this.dynamicDialogRef.close();
  }
  save(event: any) {
    if (!event.valid) {
      this.messageService.add({
        closable: false, severity: "error", detail: this.translateService.instant("component.contacts.detail.form_incomplete")
      });
      return;
    }
    if (this.contact.email != null) this.contact.email = this.contact.email.trim();
    if (this.contact.email != null && this.contact.email.length > 0 && !this.validateEmail(this.contact.email)) {
      this.messageService.add({
        closable: false, severity: "error", detail: this.translateService.instant("component.contacts.detail.invalid_mail")
      });
      return;
    }

    if (typeof this.contact.id === "undefined") {
      this.contactService.addAndLinkTask({ contact: this.contact, task_id: this.task_id }).subscribe({
        next: (data: any) => {
          this.messageService.add({
            closable: false, severity: 'success', summary: this.translateService.instant("component.contacts.detail.add_contact_correct")
          });
          this.dynamicDialogRef.close(data);
        },
        error: (error: any) => {
          this.messageService.add({ closable: false, severity: "error", detail: error.error.title });
        }
      });
    }
  }

  confirmMoveData() {
    this.coreDialogService.confirm({
      message: this.translateService.instant("component.contacts.detail.confirm_move_data"),
      header: this.translateService.instant("general.confirmation_delete_title"),
      icon: "pi pi-info-circle",
      accept: () => {
        this.contactService.changeOrganizationAndSave(this.contact.id, this.contact, true).subscribe({
          next: (data: any) => {
            this.messageService.add({ closable: false, severity: "success", detail: this.translateService.instant("component.contacts.detail.save_contact_correct") });
            //this.dynamicDialogRef.close(data);
            this._location.back();
          },
          error: (error: any) => {
            this.messageService.add({ closable: false, severity: "error", detail: error.error.title });
          }
        });
      },
      reject: () => {
        this.contactService.changeOrganizationAndSave(this.contact.id, this.contact).subscribe({
          next: (data: any) => {
            this.messageService.add({ closable: false, severity: "success", detail: this.translateService.instant("component.contacts.detail.add_contact_correct") });
            this._location.back();
          },
          error: (error: any) => {
            this.messageService.add({ closable: false, severity: "error", detail: error.error.title });
          }
        });
      }
    })
  }

  delete() {
    this.coreDialogService.confirm({
      message: this.translateService.instant("component.organizations.delete_message", { name: this.contact.name }),
      header: this.translateService.instant("general.confirmation_delete_title"), // this.translateService.instant("general.confirmation_delete_title"),
      icon: "pi pi-info-circle",
      accept: () => {
        this.contactService.delete(this.contact.id).subscribe({
          next: (data: any) => {
            this.messageService.add({ closable: false, severity: 'success', detail: this.translateService.instant("general.confirmation_delete") });
            //this.dynamicDialogRef.close();
            //this._location.back();
            if (this.previousUrl != null && this.previousUrl != "") {
              this.router.navigate([this.previousUrl]);
            } else {
              this.router.navigate(['/contacts']);
            }
          },
          error: (error: any) => {
            this.messageService.add({ closable: false, severity: 'error', detail: error.error.title });
          }
        });
      },
      reject: () => {

      }
    })
  }
  newMail(emailAcc) {
    const ref = this.dialogService.open(MailingDetailComponent, {
      data: {
        to: emailAcc,
        entity_id: 2,
        entity_pk_id: this.contact.id,
        organization_id: this.contact.organization_id,
        contact_id: this.contact.id,
        //template_type_id: 1,
        template_type_code: "MAIL",
        searchRelated: true
      },
      header: this.translateService.instant("general.new_mail_title"),//"Nuevo mensaje de correo",
      width: '70%',
    });
    ref.onClose.subscribe((data: any) => {
      if (data) {
        //this.dynamicDialogRef.close(data);
        location.reload();
      }
      if (typeof (this.view) !== "undefined") this.viewsService.changeView(this.view.code);
    });
  }

  isDuplied(contact, event) {
    if (!event.valid) {
      this.messageService.add({ closable: false, severity: "error", detail: this.translateService.instant("general.form_incomplete") });
      return;
    }
    this.contactService.isDuplied(contact).subscribe(
      data => {
        if (data == true) {
          this.coreDialogService.notify({
            message: this.translateService.instant("component.contacts.detail.contact_duplicate"), //"Ya existe un contacto con estos datos proporcionados.",
            header: this.translateService.instant("general.error"),
            icon: 'far, exclamation-circle',
            color: 'var(--orange-500)',
            accept: () => { }
          });
        } else {
          this.save(event);
        }
      }
    );
  }

  refreshAll() {
    this.view.view?.configuration?.components?.array?.forEach(component => {
      this.view.fireEvent(component.code, "reload");
    });
    this.view.fireEvent("contacts.campaigns", "reload");
  }


  openNotificationStats() {
    const ref = this.dialogService.open(MailMarketingNotificationToStatsComponent, {
      data: {
        //organization_id: this.contact.organization_id,
        contact_id: this.contact.id,
      },
      header: this.translateService.instant("component.contacts.detail.report_clicks"),
      width: '70%'
    });
    ref.onClose.subscribe((data: any) => {
      //nothing
    })
  }

  openCall(tlfn: string): void {
    // Verificar si el navegador soporta la función de llamada telefónica
    if ('open' in window) {
      // Utilizar el protocolo tel: seguido del número de teléfono
      window.open(`tel:${tlfn}`);
    } else {
      // Manejar el caso donde la función de llamada telefónica no está soportada
      console.log('Tu navegador no soporta la función de llamada telefónica.');
    }
  }


  validateEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }

  openEmails() {
    if (this.contact.id != null) this.router.navigate(["/emails", (this.organization.id ? this.organization.id : 0), this.contact.id]);
  }

  alertDisable() {
    this.coreDialogService.notify({
      message: this.translateService.instant("component.contacts.detail.disabled_contact_alert"),//"Se ha dado de baja el contacto.",
      header: this.translateService.instant("general.error"),
      icon: 'far exclamation-circle',
      color: 'var(--orange-500)',
      accept: () => {
        this.messageService.add({ closable: false, severity: "success", detail: this.translateService.instant("component.contacts.detail.save_contact_correct") });
        this._location.back();
      }
    });
  }
  unlinkCampaign(campaign) {
    this.coreDialogService.confirm({
      message: this.translateService.instant("component.contacts.unlink_campaign", { name: campaign.name }),
      header: this.translateService.instant("general.confirmation_delete_title"),
      icon: "pi pi-info-circle",
      accept: () => {
        this.campaignContactsService.unlinkContact({ contact_id: this.contact.id, campaign_id: campaign.id }).subscribe({
          next: (data: any) => {
            this.messageService.add({ closable: false, severity: 'success', detail: this.translateService.instant("general.confirmation_delete") });
            this.refreshAll();
            //this.dynamicDialogRef.close();
          },
          error: (error: any) => {
            this.messageService.add({ closable: false, severity: 'error', detail: error.error.title });
          }
        })
      },
      reject: () => {

      }
    });
  }
  openCampaign(campaign) {
    window.open("/campaigns/" + (campaign.id ? campaign.id : 0));
  }

  addCampaigns() {
    const ref = this.dialogService.open(AddCampaignsToEntityComponent, {
      data: {
        id: this.contact.id,
        entity: 'contact'
      },
      header: this.translateService.instant("component.campaigns.addCampaigns"),
      width: '70%'
    });
    ref.onClose.subscribe((data: any) => {
      this.refreshAll();
    });
  };

  onEvent(event: any) {
    if (event.component == "contacts.detail") {
      if (event.event == "action" && event.action.name == "openNotificationStats") this.openNotificationStats();
      if (event.event == "action" && event.action.name == "delete") this.delete();
      if (event.event == "action" && event.action.name == "cancel") this.cancel();
      if (event.event == "action" && event.action.name == "save") this.isDuplied(this.contact, event);
      if (event.event == "fieldAction" && event.action.name == "new-mail") this.newMail(event.value);
      if (event.event == "action" && event.action.name == "openNotificationsStats") this.openNotificationStats();
      if (event.event == "action" && event.action.name == "openEmails") this.openEmails();
      if (event.event == "fieldAction" && event.action.name == "openCall") this.openCall(event.value);
    }
    else if (event.component == "contacts.campaigns") {
      if (event.event == "action" && event.action.name == "add") this.addCampaigns();
      if (event.event == "action" && event.action.name == "edit") this.openCampaign(event.data);
      if (event.event == "action" && event.action.name == "unlink") this.unlinkCampaign(event.data);
    }
    if (event.component == "view" && event.event == "entity-loaded") {
      //this.config.header = typeof (this.contact.id) !== "undefined" ? "Detalles del " + this.view.getEntityBaseName() : "Nuevo " + this.view.getEntityBaseName();
    }
  }
}
